import { useState, useEffect } from "react";

export function useTypingEffect(text: string, speed = 10) {
  const [typedText, setTypedText] = useState("");

  useEffect(() => {
    setTypedText("");
    if (!text) return;

    let index = 0;
    const timer = setInterval(() => {
      const character = text.charAt(index);
      setTypedText((prev) => prev + character);
      index++;
      if (index >= text.length) clearInterval(timer);
    }, speed);

    return () => clearInterval(timer);
  }, [text, speed]);

  return typedText;
}
